export const IconSheet = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.38268 2.39752L11.8577 0.901683C11.9168 0.893203 11.977 0.89753 12.0343 0.914371C12.0916 0.931212 12.1447 0.960174 12.1898 0.999294C12.2349 1.03841 12.2711 1.08678 12.2959 1.14111C12.3207 1.19544 12.3335 1.25446 12.3335 1.31418V18.6859C12.3335 18.7455 12.3207 18.8044 12.2959 18.8587C12.2712 18.913 12.2351 18.9613 12.1901 19.0004C12.145 19.0395 12.0921 19.0685 12.0349 19.0854C11.9777 19.1023 11.9176 19.1067 11.8585 19.0983L1.38185 17.6025C1.1832 17.5742 1.00143 17.4752 0.869923 17.3236C0.73842 17.1721 0.666018 16.9782 0.666016 16.7775V3.22252C0.666018 3.02186 0.73842 2.82794 0.869923 2.67639C1.00143 2.52483 1.1832 2.42581 1.38185 2.39752H1.38268ZM13.1668 2.50002H16.5002C16.7212 2.50002 16.9332 2.58781 17.0894 2.74409C17.2457 2.90037 17.3335 3.11234 17.3335 3.33335V16.6667C17.3335 16.8877 17.2457 17.0997 17.0894 17.2559C16.9332 17.4122 16.7212 17.5 16.5002 17.5H13.1668V2.50002ZM7.50018 10L9.83352 6.66668H7.83352L6.50018 8.57168L5.16685 6.66668H3.16685L5.50018 10L3.16685 13.3333H5.16685L6.50018 11.4283L7.83352 13.3333H9.83352L7.50018 10Z"
        fill="#39884E"
      />
    </svg>
  );
};
